var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      staticClass: "mr-1 btn-group align-top",
      attrs: {
        "data-cy": "top-dropdown-category",
        text: `${_vm.$t("product.category")}: ${_vm.label}`,
        variant: "outline-dark",
        size: "xs",
        "no-flip": "",
      },
    },
    _vm._l(_vm.selectableProductCategories, function (category, index) {
      return _c(
        "b-dropdown-item",
        {
          key: index,
          attrs: { "data-cy": `top-dropdown-category-item-${index}` },
          on: {
            click: function ($event) {
              return _vm.onClick(category)
            },
          },
        },
        [_vm._v("\n  " + _vm._s(category.label) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }